function endlist(str, context) {
  return context.segments.length + 1;
}

module.exports = endlist;